var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.906,
    height: 11.451,
    viewBox: "0 0 8.906 11.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-outline-delete-outline",
    "data-name": "Icon material-outline-delete-outline",
    d: "M8.136,14.679a1.276,1.276,0,0,0,1.272,1.272H14.5a1.276,1.276,0,0,0,1.272-1.272V7.045H8.136ZM9.409,8.317H14.5v6.362H9.409ZM14.18,5.136,13.544,4.5H10.363l-.636.636H7.5V6.409h8.906V5.136Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#d0d5dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.a302d16515026e1ea49a2ada1a8b990a.svg";
export { ForwardRef as ReactComponent };